import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg border border-gray-200 shadow-sm p-4 mt-6" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mb-3 p-2 bg-blue-50 border border-blue-200 rounded-lg" }
const _hoisted_5 = { class: "text-xs font-bold text-blue-800 mb-1" }
const _hoisted_6 = { class: "text-xs text-black italic" }
const _hoisted_7 = { class: "overflow-x-auto" }
const _hoisted_8 = { class: "min-w-full divide-y divide-gray-200 text-xs" }
const _hoisted_9 = { class: "bg-gray-50" }
const _hoisted_10 = { class: "px-2 py-2 text-center text-xs font-medium text-black uppercase" }
const _hoisted_11 = ["checked", "indeterminate"]
const _hoisted_12 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["checked", "onChange"]
const _hoisted_15 = { class: "px-2 py-2 whitespace-nowrap text-xs text-black font-medium" }
const _hoisted_16 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_17 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_18 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_19 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_20 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_21 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_22 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_23 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "px-2 py-2 whitespace-nowrap text-xs text-black" }
const _hoisted_28 = { class: "px-2 py-2 whitespace-nowrap text-xs text-black" }
const _hoisted_29 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_30 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_34 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_35 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_36 = {
  key: 0,
  class: "text-blue-600"
}
const _hoisted_37 = {
  key: 1,
  class: "text-black"
}
const _hoisted_38 = { class: "px-2 py-2 text-xs text-black" }
const _hoisted_39 = { class: "flex items-center gap-2" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "bg-gray-50"
}
const _hoisted_44 = {
  colspan: "19",
  class: "p-0"
}
const _hoisted_45 = { class: "bg-white border border-gray-200 rounded mx-1 my-1 p-3" }
const _hoisted_46 = { class: "flex items-center justify-between mb-2" }
const _hoisted_47 = { class: "text-xs font-semibold text-black" }
const _hoisted_48 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_49 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2" }
const _hoisted_50 = {
  key: 0,
  class: "text-xs bg-gray-50 p-2 rounded border"
}
const _hoisted_51 = { class: "text-black mt-1" }
const _hoisted_52 = {
  key: 1,
  class: "text-xs bg-gray-50 p-2 rounded border"
}
const _hoisted_53 = { class: "text-black mt-1" }
const _hoisted_54 = {
  key: 2,
  class: "text-xs bg-gray-50 p-2 rounded border"
}
const _hoisted_55 = { class: "text-black mt-1" }
const _hoisted_56 = {
  key: 3,
  class: "text-xs bg-gray-50 p-2 rounded border"
}
const _hoisted_57 = { class: "text-black mt-1" }
const _hoisted_58 = {
  key: 4,
  class: "text-xs bg-gray-50 p-2 rounded border"
}
const _hoisted_59 = { class: "text-black mt-1" }
const _hoisted_60 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_61 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2" }
const _hoisted_62 = { class: "flex items-center justify-between gap-2 text-xs" }
const _hoisted_63 = { class: "font-medium text-black truncate" }
const _hoisted_64 = {
  key: 0,
  class: "text-black whitespace-nowrap"
}
const _hoisted_65 = { class: "text-black whitespace-nowrap" }
const _hoisted_66 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_67 = { class: "flex flex-wrap gap-1" }
const _hoisted_68 = {
  key: 0,
  class: "ml-1 text-xs"
}
const _hoisted_69 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_70 = { class: "flex flex-wrap gap-1" }
const _hoisted_71 = { class: "grid grid-cols-2 md:grid-cols-4 gap-3 text-xs" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "text-black" }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "text-black" }
const _hoisted_76 = { key: 2 }
const _hoisted_77 = { class: "text-black" }
const _hoisted_78 = { key: 3 }
const _hoisted_79 = { class: "text-black" }
const _hoisted_80 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_81 = { class: "lg:hidden" }
const _hoisted_82 = { class: "text-sm text-black text-center mb-4" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = {
  key: 1,
  class: "text-black italic"
}
const _hoisted_85 = { class: "flex flex-col items-center gap-2 w-full max-w-xs mx-auto" }
const _hoisted_86 = { class: "hidden lg:flex lg:items-center lg:justify-between" }
const _hoisted_87 = { class: "text-sm text-black" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = {
  key: 1,
  class: "text-black italic"
}
const _hoisted_90 = { class: "flex items-center gap-2" }
const _hoisted_91 = { class: "flex justify-end gap-2" }

import { ref, computed, watch } from 'vue'
import { ActionButton, ModalComp } from '@/components'
import type { MelReference } from '@/types/mel'
import type { ReferenceLookupData } from '@/types/mel-components'
import { formatDeclinaisonLabel } from '@/utils/declinaisonLabel'

interface Props {
  references: MelReference[]
  source: 'form' | 'excel'
  lookupData: ReferenceLookupData
  loading?: boolean
  primaryActionLabel?: string
  showPrimaryAction?: boolean
  shootingOnly?: boolean
}

interface Emits {
  (e: 'remove', id: string): void
  (e: 'confirm', selectedIds: string[], action: 'primary' | 'shooting'): void
  (e: 'duplicate', reference: MelReference): void
  (e: 'clearAll'): void
  (e: 'edit', reference: MelReference): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MelReferencesTable',
  props: {
    references: {},
    source: {},
    lookupData: {},
    loading: { type: Boolean, default: false },
    primaryActionLabel: { default: 'Ajouter mes photos' },
    showPrimaryAction: { type: Boolean, default: true },
    shootingOnly: { type: Boolean, default: false }
  },
  emits: ["remove", "confirm", "duplicate", "clearAll", "edit"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const selectedId = ref<string | null>(null)
const selectedIds = ref<Set<string>>(new Set())

// Nettoyer selectedIds quand des références sont supprimées
watch(
  () => props.references,
  (newRefs) => {
    const validIds = new Set(newRefs.map(r => r.id))
    const currentSelected = selectedIds.value
    let hasStale = false
    for (const id of currentSelected) {
      if (!validIds.has(id)) {
        hasStale = true
        break
      }
    }
    if (hasStale) {
      selectedIds.value = new Set(
        Array.from(currentSelected).filter(id => validIds.has(id))
      )
    }
  },
  { deep: false }
)

const expandedColors = ref<Set<string>>(new Set())
const showClearConfirm = ref(false)

const handleClearAll = () => {
  showClearConfirm.value = false
  emit('clearAll')
}

const isAllSelected = computed(() => {
  return props.references.length > 0 && selectedIds.value.size === props.references.length
})

const isIndeterminate = computed(() => {
  return selectedIds.value.size > 0 && selectedIds.value.size < props.references.length
})

const toggleSelect = (id: string) => {
  const newSet = new Set(selectedIds.value)
  if (newSet.has(id)) {
    newSet.delete(id)
  } else {
    newSet.add(id)
  }
  selectedIds.value = newSet
}

const toggleSelectAll = () => {
  if (isAllSelected.value) {
    selectedIds.value = new Set()
  } else {
    selectedIds.value = new Set(props.references.map(r => r.id))
  }
}

const actionLabel = (label: string) => {
  const count = selectedIds.value.size || props.references.length
  return `${label} (${count})`
}

const handleConfirm = (action: 'primary' | 'shooting') => {
  // If no selection, emit all ids; otherwise emit selected ids
  const ids = selectedIds.value.size > 0 
    ? Array.from(selectedIds.value)
    : props.references.map(r => r.id)
  emit('confirm', ids, action)
}

const toggleDetails = (id: string) => {
  selectedId.value = selectedId.value === id ? null : id
}

const toggleColorExpand = (id: string) => {
  const newSet = new Set(expandedColors.value)
  if (newSet.has(id)) {
    newSet.delete(id)
  } else {
    newSet.add(id)
  }
  expandedColors.value = newSet
}

const getMainColor = (reference: MelReference) => {
  if (!reference.couleurs || reference.couleurs.length === 0) return null
  // Trouver la couleur principale (isMain=true) ou prendre la première
  const main = reference.couleurs.find(c => c.isMain)
  return main || reference.couleurs[0]
}

const getOtherColors = (reference: MelReference) => {
  if (!reference.couleurs || reference.couleurs.length <= 1) return []
  const mainColor = getMainColor(reference)
  return reference.couleurs.filter(c => c.id !== mainColor?.id)
}

const getCategorieFullPath = (reference: MelReference): string => {
  const parts: string[] = []
  if (reference.categorieLibelle) parts.push(reference.categorieLibelle)
  if (reference.sousCategorieLibelle) parts.push(reference.sousCategorieLibelle)
  if (reference.sousSousCategorieLibelle) parts.push(reference.sousSousCategorieLibelle)
  if (parts.length > 0) return parts.join(' > ')
  // Fallback: lookup by id
  return getDisplayValue('categorie', reference.categorie)
}

const resolveCompositionMateriauLabel = (id: number): string | null => {
  const list = props.lookupData.compositionMateriaux
  if (!list?.length || !Number.isFinite(id) || id <= 0) return null
  const hit = list.find((m) => Number(m.id) === id)
  return hit ? hit.label : null
}

const getCompositionLabel = (comp: NonNullable<MelReference['compositions']>[number]): string => {
  const lookup = props.lookupData.compositionMateriaux
  const idFromField = Number(comp.compositionId ?? comp.id_composition)
  if (Number.isFinite(idFromField) && idFromField > 0) {
    const fromLookup = resolveCompositionMateriauLabel(idFromField)
    if (fromLookup) return fromLookup
  }

  const candidates = [
    comp.materiau,
    comp.compositionName,
    comp.libelle,
    comp.name,
  ]
    .map((s) => String(s ?? '').trim())
    .filter(Boolean)

  for (const t of candidates) {
    if (!/^\d+$/.test(t)) return t
  }

  for (const t of candidates) {
    if (/^\d+$/.test(t) && lookup?.length) {
      const n = parseInt(t, 10)
      const fromLookup = resolveCompositionMateriauLabel(n)
      if (fromLookup) return fromLookup
    }
  }

  if (candidates.length) return candidates[0]
  if (Number.isFinite(idFromField) && idFromField > 0) {
    return `Composition n°${idFromField}`
  }
  return '—'
}

const getCompositionPourcentage = (comp: NonNullable<MelReference['compositions']>[number]): string => {
  const p = comp.pourcentage ?? comp.percentage
  if (p === '' || p == null) return '0'
  const n =
    typeof p === 'string'
      ? parseFloat(String(p).replace(',', '.').replace('%', '').trim())
      : Number(p)
  if (!Number.isFinite(n)) return '0'
  return Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100)
}

const resolveCompositionLocalisationLabel = (id: number): string | null => {
  const list = props.lookupData.compositionLocalisations
  if (!list?.length || !Number.isFinite(id) || id <= 0) return null
  const hit = list.find((l) => Number(l.id) === id)
  return hit ? hit.label : null
}

const getCompositionLocalisationLabel = (comp: NonNullable<MelReference['compositions']>[number]): string => {
  // Priorité à l'id (source de vérité) pour éviter un libellé par défaut erroné type « Produit ».
  const locIdNum = Number(comp.localisationId)
  if (Number.isFinite(locIdNum) && locIdNum > 0) {
    const resolved = resolveCompositionLocalisationLabel(locIdNum)
    if (resolved) return `Zone : ${resolved}`
  }

  const loc = comp.localisation
  if (loc != null && loc !== '' && loc !== '0') {
    const locStr = String(loc).trim()
    if (/^\d+$/.test(locStr)) {
      const n = parseInt(locStr, 10)
      if (n > 0) {
        const resolved = resolveCompositionLocalisationLabel(n)
        if (resolved) return `Zone : ${resolved}`
        return `Zone (id) : ${locStr}`
      }
    }
  }

  const byName = comp.localisationName?.trim()
  if (byName) return `Zone : ${byName}`

  if (loc == null || loc === '' || loc === '0') return ''
  const locStrFree = String(loc).trim()
  return locStrFree ? `Zone : ${locStrFree}` : ''
}

const getDisplayValue = (type: string, value: any, libelle?: string): string => {
  if (!value && !libelle) return '-'
  
  switch (type) {
    case 'marque': {
      // Priorité au libellé fourni directement (depuis la base de données) - compatible avec l'ancien PHP
      if (libelle) return libelle
      if (!value) return '-'
      // Compatibilité: value peut être string ou number, marques.id est number
      const valueNum = typeof value === 'string' ? parseInt(value, 10) : value
      const marque = props.lookupData.marques.find(m => m.id === valueNum || m.value === value?.toString())
      return marque ? marque.label : value
    }
    
    case 'categorie': {
      if (libelle) return libelle
      const categorie = props.lookupData.categories.find(c => c.id === parseInt(value))
      return categorie ? categorie.label : value
    }
    
    case 'collection': {
      const collection = props.lookupData.collections.find(c => c.id.toString() === value.toString())
      return collection ? collection.label : value
    }
    
    case 'pays': {
      const pays = props.lookupData.provenances.find(p => p.id.toString() === value.toString())
      return pays ? pays.label : value
    }
    
    case 'taillePaquet': {
      if (!props.lookupData.declinaisons) return value
      const declinaison = props.lookupData.declinaisons.find(d => d.id.toString() === value.toString())
      return declinaison
        ? formatDeclinaisonLabel(declinaison.label, declinaison.tailles)
        : value
    }
    
    case 'quantitePaquet': {
      if (!props.lookupData.packs) return value
      const pack = props.lookupData.packs.find(p => p.id.toString() === value.toString())
      return pack ? (pack.value ? `${pack.label} (${pack.value})` : pack.label) : value
    }
    
    default:
      return value
  }
}

const formatDateFr = (rawDate: string | null | undefined): string => {
  const value = String(rawDate ?? '').trim()
  if (!value) return '-'

  // Déjà en jj/mm/aaaa
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value

  // Formats ISO/mysql: yyyy-mm-dd ou yyyy-mm-dd HH:mm:ss
  const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (isoMatch) {
    const [, y, m, d] = isoMatch
    return `${d}/${m}/${y}`
  }

  // Fallback: tenter un parse JS
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return value
  const d = String(parsed.getDate()).padStart(2, '0')
  const m = String(parsed.getMonth() + 1).padStart(2, '0')
  const y = parsed.getFullYear()
  return `${d}/${m}/${y}`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[51] || (_cache[51] = _createElementVNode("h3", { class: "text-base font-bold text-black mb-3" }, "Liste des références à valider", -1)),
    (_ctx.references.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[13] || (_cache[13] = [
          _createElementVNode("div", { class: "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4" }, [
            _createElementVNode("i", { class: "fas fa-box text-black text-2xl" })
          ], -1),
          _createElementVNode("p", { class: "text-black" }, "Aucun produit n'a été ajouté pour votre demande de mise en ligne.", -1)
        ])))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, " Liste des références à valider (" + _toDisplayString(_ctx.references.length) + " référence" + _toDisplayString(_ctx.references.length > 1 ? 's' : '') + ") ", 1),
            _createElementVNode("p", _hoisted_6, " Toutes les références ajoutées via " + _toDisplayString(_ctx.source === 'form' ? 'le formulaire en ligne' : 'Excel') + " sont listées ci-dessous avec tous leurs détails. ", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _createElementVNode("thead", _hoisted_9, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_10, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: isAllSelected.value,
                      indeterminate: isIndeterminate.value,
                      onChange: toggleSelectAll,
                      class: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer",
                      title: "Sélectionner tout"
                    }, null, 40, _hoisted_11)
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Référence", -1)),
                  _cache[15] || (_cache[15] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Marque", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Categorie", -1)),
                  _cache[17] || (_cache[17] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Vendu Par", -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Collection", -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Pays Origine", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Taille Paquet", -1)),
                  _cache[21] || (_cache[21] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Qté Paquet", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Stock", -1)),
                  _cache[23] || (_cache[23] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Prix", -1)),
                  _cache[24] || (_cache[24] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Prix Réd.", -1)),
                  _cache[25] || (_cache[25] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Poids", -1)),
                  _cache[26] || (_cache[26] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Couleur", -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Min. Cmd", -1)),
                  _cache[28] || (_cache[28] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Dimensions", -1)),
                  _cache[29] || (_cache[29] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Caract.", -1)),
                  _cache[30] || (_cache[30] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase" }, "Date Création", -1)),
                  _cache[31] || (_cache[31] = _createElementVNode("th", { class: "px-2 py-2 text-left text-xs font-medium text-black uppercase sticky right-0 bg-gray-50 z-10" }, "Action", -1))
                ])
              ]),
              _createElementVNode("tbody", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.references, (reference) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: reference.id
                  }, [
                    _createElementVNode("tr", {
                      onClick: ($event: any) => (toggleDetails(reference.id)),
                      class: _normalizeClass([
                  'cursor-pointer transition-colors',
                  selectedId.value === reference.id ? 'bg-blue-50' : 'hover:bg-gray-50',
                  selectedIds.value.has(reference.id) ? 'bg-green-50' : ''
                ])
                    }, [
                      _createElementVNode("td", {
                        class: "px-2 py-2 text-center",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: selectedIds.value.has(reference.id),
                          onChange: ($event: any) => (toggleSelect(reference.id)),
                          class: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                        }, null, 40, _hoisted_14)
                      ]),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(reference.reference || '-'), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(getDisplayValue('marque', reference.marque)), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(getCategorieFullPath(reference)), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(reference.venduPar || '-'), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(getDisplayValue('collection', reference.collection)), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(getDisplayValue('pays', reference.paysOrigine)), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(getDisplayValue('taillePaquet', reference.taillePaquet)), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(reference.venduPar === 'tailles' ? '-' : getDisplayValue('quantitePaquet', reference.quantitePaquet)), 1),
                      _createElementVNode("td", _hoisted_23, [
                        (reference.venduPar === 'couleurs' && reference.couleurs && reference.couleurs.some((c) => c.stock != null))
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(reference.couleurs.filter((c) => c.stock != null), (c, idx) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: c.id
                              }, [
                                _createTextVNode(_toDisplayString(c.nom) + "*" + _toDisplayString((c as any).stock), 1),
                                (idx < reference.couleurs.filter((c) => c.stock != null).length - 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, ", "))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          : (reference.venduPar === 'tailles' && reference.couleurs && reference.couleurs.some((c) => Array.isArray((c as any).tailleStocks) && (c as any).tailleStocks.some((ts) => ts.quantity != null)))
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(reference.couleurs.filter((c) => Array.isArray((c as any).tailleStocks)), (c, cidx) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: c.id
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((c as any).tailleStocks.filter((ts) => ts.quantity != null), (ts, tidx) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: ts.taille
                                    }, [
                                      _createTextVNode(_toDisplayString(c.nom) + "*" + _toDisplayString(ts.taille) + "*" + _toDisplayString(ts.quantity), 1),
                                      (tidx < (c as any).tailleStocks.filter((ts) => ts.quantity != null).length - 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, ","))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128)),
                                  (cidx < reference.couleurs.filter((c) => Array.isArray((c as any).tailleStocks)).length - 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, ", "))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(reference.stock || '-'), 1)
                              ], 64))
                      ]),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(reference.prix ? `${reference.prix}€` : '-'), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(reference.prixReduit ? `${reference.prixReduit}€` : '-'), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(reference.poids || '-'), 1),
                      _createElementVNode("td", _hoisted_30, [
                        (reference.couleurs && reference.couleurs.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(reference.couleurs.length) + " couleur" + _toDisplayString(reference.couleurs.length > 1 ? 's' : ''), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))
                      ]),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(reference.minimumCommande || '-'), 1),
                      _createElementVNode("td", _hoisted_34, _toDisplayString(reference.dimensions || '-'), 1),
                      _createElementVNode("td", _hoisted_35, [
                        (reference.caracteristiques && reference.caracteristiques.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(reference.caracteristiques.length) + " caract. ", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_37, "-"))
                      ]),
                      _createElementVNode("td", _hoisted_38, _toDisplayString(reference.dateCreation), 1),
                      _createElementVNode("td", {
                        class: "px-2 py-2 whitespace-nowrap text-sm font-medium sticky right-0 bg-white z-10",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("button", {
                            onClick: _withModifiers(($event: any) => (_ctx.$emit('edit', reference)), ["stop"]),
                            class: "px-2 py-1 bg-green-600 text-white rounded hover:bg-green-700",
                            title: "Modifier cette référence"
                          }, _cache[32] || (_cache[32] = [
                            _createElementVNode("i", { class: "fas fa-pen text-xs" }, null, -1)
                          ]), 8, _hoisted_40),
                          _createElementVNode("button", {
                            onClick: _withModifiers(($event: any) => (_ctx.$emit('duplicate', reference)), ["stop"]),
                            class: "px-2 py-1 bg-amber-600 text-white rounded hover:bg-amber-700",
                            title: "Dupliquer"
                          }, _cache[33] || (_cache[33] = [
                            _createElementVNode("i", { class: "fas fa-layer-group text-xs" }, null, -1)
                          ]), 8, _hoisted_41),
                          _createElementVNode("button", {
                            onClick: _withModifiers(($event: any) => (_ctx.$emit('remove', reference.id)), ["stop"]),
                            class: "px-2 py-1 bg-red-600 text-white rounded hover:bg-red-700",
                            title: "Supprimer cette référence"
                          }, _cache[34] || (_cache[34] = [
                            _createElementVNode("i", { class: "fas fa-trash text-xs" }, null, -1)
                          ]), 8, _hoisted_42)
                        ])
                      ])
                    ], 10, _hoisted_13),
                    (selectedId.value === reference.id)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                          _createElementVNode("td", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("h5", _hoisted_47, " Détails de la référence : " + _toDisplayString(reference.reference), 1),
                                _createElementVNode("button", {
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedId.value = null)),
                                  class: "text-black hover:text-black text-xs"
                                }, _cache[35] || (_cache[35] = [
                                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                ]))
                              ]),
                              (reference.descriptionFr || reference.descriptionEn || reference.descriptionIt || reference.descriptionEs || reference.descriptionDe)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _cache[41] || (_cache[41] = _createElementVNode("h6", { class: "text-xs font-medium text-black mb-1" }, "Descriptions :", -1)),
                                    _createElementVNode("div", _hoisted_49, [
                                      (reference.descriptionFr)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "font-medium text-black" }, "FR :", -1)),
                                            _createElementVNode("div", _hoisted_51, _toDisplayString(reference.descriptionFr), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (reference.descriptionEn)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "font-medium text-black" }, "EN :", -1)),
                                            _createElementVNode("div", _hoisted_53, _toDisplayString(reference.descriptionEn), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (reference.descriptionIt)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "font-medium text-black" }, "IT :", -1)),
                                            _createElementVNode("div", _hoisted_55, _toDisplayString(reference.descriptionIt), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (reference.descriptionEs)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                            _cache[39] || (_cache[39] = _createElementVNode("span", { class: "font-medium text-black" }, "ES :", -1)),
                                            _createElementVNode("div", _hoisted_57, _toDisplayString(reference.descriptionEs), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (reference.descriptionDe)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "font-medium text-black" }, "DE :", -1)),
                                            _createElementVNode("div", _hoisted_59, _toDisplayString(reference.descriptionDe), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (reference.compositions && reference.compositions.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                    _cache[42] || (_cache[42] = _createElementVNode("h6", { class: "text-xs font-medium text-black mb-1" }, "Compositions :", -1)),
                                    _createElementVNode("div", _hoisted_61, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reference.compositions, (comp, idx) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: idx,
                                          class: "text-xs bg-gray-50 p-2 rounded border"
                                        }, [
                                          _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("span", _hoisted_63, _toDisplayString(getCompositionLabel(comp)), 1),
                                            (getCompositionLocalisationLabel(comp))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(getCompositionLocalisationLabel(comp)), 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("span", _hoisted_65, _toDisplayString(getCompositionPourcentage(comp)) + " % ", 1)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (reference.couleurs && reference.couleurs.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                    _cache[43] || (_cache[43] = _createElementVNode("h6", { class: "text-xs font-medium text-black mb-1" }, "Couleurs :", -1)),
                                    _createElementVNode("div", _hoisted_67, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reference.couleurs, (couleur) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: couleur.id,
                                          class: _normalizeClass([
                            'inline-flex items-center px-2 py-1 rounded-full text-xs border',
                            couleur.isMain 
                              ? 'bg-blue-500 text-white border-blue-600 font-medium' 
                              : 'bg-gray-100 text-black border-gray-300'
                          ])
                                        }, [
                                          _createTextVNode(_toDisplayString(couleur.nom) + " ", 1),
                                          (couleur.isMain)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, "★"))
                                            : _createCommentVNode("", true)
                                        ], 2))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (reference.caracteristiques && reference.caracteristiques.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                    _cache[45] || (_cache[45] = _createElementVNode("h6", { class: "text-xs font-medium text-black mb-1" }, "Caractéristiques sélectionnées :", -1)),
                                    _createElementVNode("div", _hoisted_70, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reference.caracteristiques, (carac) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: carac.id,
                                          class: "inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 border border-blue-200"
                                        }, [
                                          _cache[44] || (_cache[44] = _createElementVNode("i", { class: "fas fa-check-circle mr-1 text-xs" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(carac.libelle), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_71, [
                                (reference.dateRemise)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                      _cache[46] || (_cache[46] = _createElementVNode("span", { class: "font-medium text-black" }, "Date remise :", -1)),
                                      _createElementVNode("div", _hoisted_73, _toDisplayString(formatDateFr(reference.dateRemise)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (reference.pourcentageRemise)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                      _cache[47] || (_cache[47] = _createElementVNode("span", { class: "font-medium text-black" }, "% Remise :", -1)),
                                      _createElementVNode("div", _hoisted_75, _toDisplayString(reference.pourcentageRemise) + "%", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (reference.stock)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                      _cache[48] || (_cache[48] = _createElementVNode("span", { class: "font-medium text-black" }, "Stock :", -1)),
                                      _createElementVNode("div", _hoisted_77, _toDisplayString(reference.stock), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (reference.poids)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                      _cache[49] || (_cache[49] = _createElementVNode("span", { class: "font-medium text-black" }, "Poids :", -1)),
                                      _createElementVNode("div", _hoisted_79, _toDisplayString(reference.poids), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ]),
          (_ctx.references.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    (selectedIds.value.size > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(selectedIds.value.size) + " référence" + _toDisplayString(selectedIds.value.size > 1 ? 's' : '') + " sélectionnée" + _toDisplayString(selectedIds.value.size > 1 ? 's' : ''), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_84, " Aucune sélection (toutes les références seront mises en ligne) "))
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    (_ctx.shootingOnly || _ctx.showPrimaryAction)
                      ? (_openBlock(), _createBlock(_unref(ActionButton), {
                          key: 0,
                          label: _ctx.shootingOnly ? 'Faire une demande' : actionLabel('Faire une demande'),
                          variant: _ctx.showPrimaryAction && !_ctx.shootingOnly ? 'success' : 'primary',
                          icon: "fas fa-camera",
                          customClass: "w-full",
                          loading: _ctx.loading,
                          disabled: _ctx.loading,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleConfirm('shooting')))
                        }, null, 8, ["label", "variant", "loading", "disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.showPrimaryAction && !_ctx.shootingOnly)
                      ? (_openBlock(), _createBlock(_unref(ActionButton), {
                          key: 1,
                          label: actionLabel(_ctx.primaryActionLabel),
                          variant: "primary",
                          icon: "fas fa-images",
                          customClass: "w-full",
                          loading: _ctx.loading,
                          disabled: _ctx.loading,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (handleConfirm('primary')))
                        }, null, 8, ["label", "loading", "disabled"]))
                      : (!_ctx.shootingOnly)
                        ? (_openBlock(), _createBlock(_unref(ActionButton), {
                            key: 2,
                            label: actionLabel('Choisir le shooting'),
                            variant: "secondary",
                            icon: "fas fa-camera",
                            customClass: "w-full",
                            disabled: _ctx.loading,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (handleConfirm('shooting')))
                          }, null, 8, ["label", "disabled"]))
                        : _createCommentVNode("", true),
                    _createVNode(_unref(ActionButton), {
                      label: "Vider les brouillons",
                      icon: "fas fa-trash",
                      variant: "danger",
                      customClass: "w-full",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (showClearConfirm.value = true))
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    (selectedIds.value.size > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(selectedIds.value.size) + " référence" + _toDisplayString(selectedIds.value.size > 1 ? 's' : '') + " sélectionnée" + _toDisplayString(selectedIds.value.size > 1 ? 's' : ''), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_89, " Aucune sélection (toutes les références seront mises en ligne) "))
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _createVNode(_unref(ActionButton), {
                      label: "Vider les brouillons",
                      icon: "fas fa-trash",
                      variant: "danger",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (showClearConfirm.value = true))
                    }),
                    (_ctx.shootingOnly || _ctx.showPrimaryAction)
                      ? (_openBlock(), _createBlock(_unref(ActionButton), {
                          key: 0,
                          label: _ctx.shootingOnly ? 'Faire une demande' : actionLabel('Faire une demande'),
                          variant: _ctx.showPrimaryAction && !_ctx.shootingOnly ? 'success' : 'primary',
                          icon: "fas fa-camera",
                          loading: _ctx.loading,
                          disabled: _ctx.loading,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (handleConfirm('shooting')))
                        }, null, 8, ["label", "variant", "loading", "disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.showPrimaryAction && !_ctx.shootingOnly)
                      ? (_openBlock(), _createBlock(_unref(ActionButton), {
                          key: 1,
                          label: actionLabel(_ctx.primaryActionLabel),
                          variant: "primary",
                          icon: "fas fa-images",
                          loading: _ctx.loading,
                          disabled: _ctx.loading,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (handleConfirm('primary')))
                        }, null, 8, ["label", "loading", "disabled"]))
                      : (!_ctx.shootingOnly)
                        ? (_openBlock(), _createBlock(_unref(ActionButton), {
                            key: 2,
                            label: actionLabel('Choisir le shooting'),
                            variant: "secondary",
                            icon: "fas fa-camera",
                            disabled: _ctx.loading,
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (handleConfirm('shooting')))
                          }, null, 8, ["label", "disabled"]))
                        : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_unref(ModalComp), {
      isVisible: showClearConfirm.value,
      title: "Confirmer la suppression",
      size: "sm",
      "onUpdate:isVisible": _cache[12] || (_cache[12] = ($event: any) => (showClearConfirm.value = $event))
    }, {
      body: _withCtx(() => _cache[50] || (_cache[50] = [
        _createElementVNode("p", { class: "text-black" }, " Êtes-vous sûr de vouloir supprimer tous les brouillons ? Cette action est irréversible. ", -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_91, [
          _createVNode(_unref(ActionButton), {
            label: "Annuler",
            variant: "secondary",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (showClearConfirm.value = false))
          }),
          _createVNode(_unref(ActionButton), {
            label: "Supprimer tout",
            variant: "danger",
            icon: "fas fa-trash",
            onClick: handleClearAll
          })
        ])
      ]),
      _: 1
    }, 8, ["isVisible"])
  ]))
}
}

})